import React, { Component } from 'react';

import Console from '../../../../lib/debug';

export default class MDItem extends Component {
    handleSelect = item => {
        this.props.onSelect(item);
    };

    shouldComponentUpdate(nextProps) {
        return this.props.item.id !== nextProps.item.id;
    }

    render() {
        Console.render('designer.MDItem');
        let item = this.props.item;
        let itemImg = null;
        let extra = null;
        if (item.icon) {
            itemImg = (
                <span className="image">
                    <img src={item.icon} alt={item.title} />
                </span>
            );
        }
        if (item.isNew) {
            extra = <span className="new"> New!</span>;
        }

        let type = null;
        if (item.eType === 'e') {
            type = <span className="chip">Exercise</span>;
        } else if (item.eType === 'wc' && item.plain_text === 1) {
            type = <span className="chip">Circuit</span>;
        } else if (item.eType === 'wc' && item.plain_text !== 1) {
            type = <span className="chip">Superset</span>;
        }
        const itemClasses = 'MegaDrop-item-metadata MegaDrop-item-extra-data';
        return (
            <div
                ref={this.props.itemRef}
                className={`MegaDrop-item${
                    this.props.isSelected ? ' selected' : ''
                }`}
                onClick={() => this.handleSelect(item)}
            >
                <div className={itemClasses}>
                    {itemImg}
                    <span className="MegaDrop-item-title">{item.title}</span>
                    {extra}
                </div>
                <div className="MegaDrop-item-metadata">
                    <div className="MegaDrop-item-title">{type}</div>
                </div>
            </div>
        );
    }
}
